import React, { createContext, type FC, type PropsWithChildren, useContext } from 'react'

/** `undefined` without a provider */
const RecordPanelOutletContext = createContext<HTMLElement | null | undefined>(undefined)

/** The outlet must be positioned; the panel fills its height. `null` while the outlet isn't mounted yet */
export const RecordPanelOutletProvider: FC<Readonly<{ outlet: HTMLElement | null }> & PropsWithChildren> = ({ outlet, children }) => (
    <RecordPanelOutletContext.Provider value={outlet}>{children}</RecordPanelOutletContext.Provider>
)

export const useRecordPanelOutlet = (): HTMLElement | null | undefined => useContext(RecordPanelOutletContext)
